import ArrowDown from '@sats-group/icons/18/arrow-down';
import Button from '@sats-group/ui-lib/react/button';
import Text from '@sats-group/ui-lib/react/text';
import React from 'react';
import ContentContainer from '../content-container/content-container';
import type { FormDialog as Props } from './form-dialog.types';

const FormDialog: React.FC<React.PropsWithChildren<Props>> = ({
  children,
  close,
  id,
  submit,
  title,
  trigger,
}) => (
  <div className="form-dialog">
    <Button
      popoverTarget={id}
      popoverTargetAction="toggle"
      text={trigger}
      trailingIcon={<ArrowDown />}
      variant={Button.variants.secondary}
      wide
    />
    <dialog className="form-dialog__dialog" id={id} popover="auto">
      <ContentContainer theme={ContentContainer.themes.narrow}>
        <div className="form-dialog__content">
          <div className="form-dialog__title">
            <Text size={Text.sizes.headline3} theme={Text.themes.emphasis}>
              {title}
            </Text>
          </div>
          <div className="form-dialog__children">{children}</div>
          <div className="form-dialog__actions">
            <Button
              popoverTarget={id}
              popoverTargetAction="hide"
              text={close}
              variant={Button.variants.secondary}
            />
            <Button
              text={submit}
              type="submit"
              variant={Button.variants.primary}
            />
          </div>
        </div>
      </ContentContainer>
    </dialog>
  </div>
);

export default FormDialog;
